import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject17() {
  var data = _taggedTemplateLiteral(["## Imports"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["", "", ""]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["## Implementation"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["## 4D Polytopes"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["## Other Interesting Projections\n\nThe following projections are interesting because require\nrelatively few \"white\" orbits, strut orbits that are unknown\nto vZome."]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n## The Green-Mirror Projection\n\nThis projection corresponds to\nreflecting the familiar red-yellow-blue projection\nthrough any green strut axis,\nor rotating it \nninety degrees around any blue strut axis.\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["## The Edge-First Projection"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["## The Face-First Projection"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n## The Vertex-First Projection"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["## The Standard Projection\n\nWith a unit quaternion on both sides of the transformation,\nwe get the well-known Zome projection of the 120-cell.\nIn a very real sense, this projection is the reason that\n[Zometool](http://zometool.com)\nexists: Marc Pelletier recognized that the earlier\n[Zometoy system](http://zometool.com/about-us/)\ndeveloped by Steve and Holly Baer could naturally\nrepresent this projection (and the same projection of the 600-cell),\nwhich he was familiar with from\nCoxeter's Regular Polytopes book.\nHe and Paul Hildebrandt ran with the idea from there.\n\nWe call this the **cell-first** projection, because there is a\ndodecahedral cell centered in the model.\nThis is the only projection that does not require the hidden-cell\nremoval, since the projections of the hidden cells are coincident\nwith the projections of the visible cells.  In other words, every\ndodecahedral cell you see is actually two aligned cells projected to\nthe same place."]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["### Just an experiment\n\nIgnore this for now."]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n## Hidden Cell Removal\n\nThere is one more thing I should say about the 120-cell projections:\nI am removing hidden cells when projecting from 4D to 3D.\nThis is analogous to hidden surface removal routinely done in 3D graphics;\nwe don't render the polygons in the mesh that are facing away from the camera,\nsince they should be hidden by other, nearer, front-facing polygons.\nIn the 4D case, we are hiding 3D polyhedral cells rather than 2D\npolygons.\n\nThe result is a much more apprehensible rendering, with no confusing overlay\nof the front and the back of the object.  For example, if I didn't do the hidden-cell removal,\nthe vertex-first projection below would have *eight* yellow struts emanating from the center\nball, and you would not see the tetrahedral symmetry of the cells.\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\nYou copy this cell output to capture the current rotation as code for a new cell\n(omitting the back-quotes):\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["", "", ""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\nThe renderings above and below are both of a 120-cell, a 4-dimensional object.  Its vertices\nall sit on the 3-sphere, the 4D analogue of the sphere you are familiar with.\nBoth are fully interactive 3D renderings -- you can rotate, pan, and zoom.\n\nBefore we go into the 4D rotations, try moving the first slider below, to the right.\nYou will see the blob of Zome balls expand into a recognizable Zome model.\nNow the triangle on the right makes sense, documenting the strut colors\n(and vector orbits under icosahedral symmetry) used in the projected object.\n\nGeneral 4D rotations can be implemented by two-sided quaternion multiplication;\nevery 4-vector gets multiplied by one quaternion from the left and one from the right.\nThe other eight controls below control these two quaternions,\neach row controlling one coordinate of the four required.\nThe number from the left input is muliplied by the\npower of phi from the right input.\nObviously a multiplier of zero leaves you with zero,\nregardless of the phi power.\n\nExperiment with the quaternion controls, and see if you can rediscover\nsome of the rotations capture in the rest of the notebook.\nThere are many ways to encode rotations that give similar results\nin terms of the orbit triangle.\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# Exploring 4D Quaternion Rotations"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/exploring-4d-quaternion-rotations@775
import define1 from "../@vorth/vzome-icosahedral-orbit-triangle.js";
import define2 from "../@vorth/wip-importing-vzome-shapes.js";
import define3 from "../@vorth/orbits-of-icosahedral-symmetry.js";
import define4 from "../@vorth/wip-importing-vzome-models.js";
import define5 from "../@vorth/observable-vzome-rendering.js";
import define6 from "../@jrus/zome-arithmetic.js";
import define7 from "../@jashkenas/inputs.js";
import define8 from "../@vorth/reusable-three-js-canvas.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[, 1], [, 1], [1], []], [[1], [], [], []], [1, 1]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell", "rotation_4d", "scale"], function (rotated4dViewOriginal, fourD_120_cell, rotation_4d, scale) {
    return rotated4dViewOriginal(this, fourD_120_cell, rotation_4d.slice().concat([scale]));
  });
  main.variable(observer("viewof scale")).define("viewof scale", ["phiPowerInput"], function (phiPowerInput) {
    return phiPowerInput(5);
  });
  main.variable(observer("scale")).define("scale", ["Generators", "viewof scale"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer("viewof rotation_4d")).define("viewof rotation_4d", ["quaternionInput", "html"], function (quaternionInput, html) {
    var leftControl = quaternionInput(5, "Left quaternion:");
    var rightControl = quaternionInput(5, "Right quaternion:");
    leftControl.style.display = 'inline';
    rightControl.style.display = 'inline';
    var element = html(_templateObject3(), leftControl, rightControl);
    element.style.display = 'inline'; // element.style['vertical-align'] = 'top';
    // element.style['column-count'] = 2;

    element.oninput = function () {
      return element.value = [leftControl.value, rightControl.value];
    };

    element.oninput();
    return element;
  });
  main.variable(observer("rotation_4d")).define("rotation_4d", ["Generators", "viewof rotation_4d"], function (G, _) {
    return G.input(_);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  main.variable(observer()).define(["rotation_4d", "scale"], function (rotation_4d, scale) {
    return "rotated4dViewOriginal( fourD_120_cell, [\n  " + JSON.stringify(rotation_4d[0]) + ",\n  " + JSON.stringify(rotation_4d[1]) + ",\n  " + JSON.stringify(scale) + "\n] )";
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject5());
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject6());
  });
  main.define("initial mscale", function () {
    return [1];
  });
  main.variable(observer("mutable mscale")).define("mutable mscale", ["Mutable", "initial mscale"], function (M, _) {
    return new M(_);
  });
  main.variable(observer("mscale")).define("mscale", ["mutable mscale"], function (_) {
    return _.generator;
  });
  main.variable(observer()).define(["phiPowerInput", "mutable mscale"], function (phiPowerInput, $0) {
    var input = phiPowerInput(5);
    var origHandler = input.oninput;

    input.oninput = function () {
      origHandler();
      $0.value = input.value;
    };

    return input;
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject7());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1], [], [], []], [[1], [], [], []], [2, 3]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject8());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1], [1], [], []], [[1], [], [], []], [1, 2]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject9());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1], [, 1], [], []], [[1], [], [], []], [1, 1]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject10());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1], [1, 1], [], []], [[1], [], [], []], [1, 1]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject11());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1, 0, 1], [1, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, 0, 1], [1, 0, 1], [0, 0, 1], [0, 0, 1]], [1, 1, 1]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject12());
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1], [, 1], [1], []], [[1], [], [], []], [1, 1]]);
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[, 1], [, 1], [1], []], [[1], [], [], []], [1, 1]]);
  });
  main.variable(observer()).define(["rotated4dViewOriginal", "fourD_120_cell"], function (rotated4dViewOriginal, fourD_120_cell) {
    return rotated4dViewOriginal(this, fourD_120_cell, [[[1, 0, 1], [-1, 1, 1], [0, 0, 1], [0, 0, 1]], [[1, 0, 1], [0, -1, 1], [0, 0, 1], [0, 0, 1]], [1, 1, 1]]);
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject13());
  });
  main.variable(observer("fourD_120_cell")).define("fourD_120_cell", function () {
    return fetch("https://gist.githubusercontent.com/vorth/53ea8016f6df2ea27c0aa653a4c63cd9/raw/3ec5ea19f167193074f80aa5551c416626733503/120-cell-4D.vson").then(function (response) {
      return response.json();
    });
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject14());
  });
  main.variable(observer("rotated4dView")).define("rotated4dView", ["width", "Geometries", "icosahedral_solid_connectors_shapes", "vZome_colors", "rotateAndProject", "meshGroup", "reusable3dCanvas", "getUsedOrbits", "icosaOrbitsTriangle", "html"], function (width, Geometries, icosahedral_solid_connectors_shapes, vZome_colors, rotateAndProject, meshGroup, reusable3dCanvas, getUsedOrbits, icosaOrbitsTriangle, html) {
    return function rotated4dView(existingElement, polytope_4d, rotor, scale) {
      var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var halfWidth = width / 2;
      var _config$height = config.height,
          height = _config$height === void 0 ? 300 : _config$height,
          _config$svgWidth = config.svgWidth,
          svgWidth = _config$svgWidth === void 0 ? halfWidth : _config$svgWidth,
          _config$renderWidth = config.renderWidth,
          renderWidth = _config$renderWidth === void 0 ? halfWidth : _config$renderWidth,
          _config$orbitControl = config.orbitControl,
          orbitControl = _config$orbitControl === void 0 ? true : _config$orbitControl;
      var solidParts = new Geometries(icosahedral_solid_connectors_shapes, vZome_colors);
      var model = rotateAndProject(polytope_4d, rotor, scale);
      var group = meshGroup(model, solidParts);
      var view4d = reusable3dCanvas(existingElement && existingElement.vZomeCanvas, group, {
        renderWidth: renderWidth,
        camera: {
          aspect: 8 / 5
        }
      });
      view4d.style.display = 'inline';
      view4d.style['vertical-align'] = 'top';
      var triangleConfig = Object.assign({}, config, {
        orbits: getUsedOrbits(model),
        svgWidth: svgWidth,
        height: height
      });
      var triangle = icosaOrbitsTriangle(triangleConfig);
      triangle.style.display = 'inline';
      triangle.style['vertical-align'] = 'top';
      var element = orbitControl ? html(_templateObject15(), view4d, triangle) : html(_templateObject16(), view4d);
      element.vZomeCanvas = view4d; // element.style.display = 'inline'
      // element.style['vertical-align'] = 'top'

      return element;
    };
  });
  main.variable(observer("rotated4dViewNoOrbit")).define("rotated4dViewNoOrbit", ["rotated4dView"], function (rotated4dView) {
    return function rotated4dViewNoOrbit(existingElement, polytope_4d, rotor, scale, config) {
      var newConfig = Object.assign({}, config, {
        orbitControl: false
      });
      return rotated4dView(existingElement, polytope_4d, rotor, scale, newConfig);
    };
  });
  main.variable(observer("rotated4dViewOriginal")).define("rotated4dViewOriginal", ["rotated4dView", "quaternionRotor"], function (rotated4dView, quaternionRotor) {
    return function (existingElement, model, rotation, config) {
      var _rotation = _slicedToArray(rotation, 3),
          left = _rotation[0],
          right = _rotation[1],
          scale = _rotation[2];

      return rotated4dView(existingElement, model, quaternionRotor(left, right), scale, config);
    };
  });
  main.variable(observer("getUsedOrbits")).define("getUsedOrbits", ["vZome_icosahedral_orbits", "IndexedSet"], function (vZome_icosahedral_orbits, IndexedSet) {
    return function getUsedOrbits(model) {
      var orbits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : vZome_icosahedral_orbits;
      var orbitSet = new IndexedSet();
      model.struts.map(function (strut) {
        return orbitSet.add(strut.orbit);
      });
      return orbitSet.contents.map(function (s) {
        var vZome_orbit = orbits[s];
        return {
          orbit: JSON.parse(s),
          color: vZome_orbit && vZome_orbit.color
        };
      });
    };
  });
  main.variable(observer("quaternionRotor")).define("quaternionRotor", ["quatmul"], function (quatmul) {
    return function (left, right) {
      return function (v) {
        return quatmul(left, quatmul(v, right));
      };
    };
  });
  main.variable(observer("rotateAndProject")).define("rotateAndProject", ["removeHiddenVertices", "convertVsonModel", "scalarmul"], function (removeHiddenVertices, convertVsonModel, scalarmul) {
    return function rotateAndProject(polytope4d, rotor, scale) {
      function dropW(vertex) {
        return vertex.slice(1, 4);
      }

      function mapVertices(vson, vertexFn) {
        return Object.assign({}, vson, {
          vertices: vson.vertices.map(vertexFn)
        });
      }

      var rotated = mapVertices(polytope4d, rotor);
      var visible = removeHiddenVertices(rotated);
      return convertVsonModel(mapVertices(visible, function (v) {
        return scalarmul(scale, dropW(v));
      }));
    };
  });
  main.variable(observer("removeHiddenVertices")).define("removeHiddenVertices", ["grfloat"], function (grfloat) {
    return function removeHiddenVertices(vson) {
      function nonNegativeW(vector) {
        return grfloat(vector[0]) >= 0;
      }

      return Object.assign({}, vson, {
        struts: vson.struts.filter(function (strut) {
          return nonNegativeW(vson.vertices[strut.start]) || nonNegativeW(vson.vertices[strut.end]);
        }),
        balls: vson.balls.filter(function (i) {
          return nonNegativeW(vson.vertices[i]);
        })
      });
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject17());
  });
  var child1 = runtime.module(define1);
  main.import("icosaOrbitsTriangle", child1);
  var child2 = runtime.module(define2);
  main.import("vZome_icosahedral_orbits", child2);
  main.import("icosahedral_solid_connectors_shapes", child2);
  main.import("vZome_colors", child2);
  var child3 = runtime.module(define3);
  main.import("orbits", "icosaOrbits", child3);
  main.import("IndexedSet", child3);
  var child4 = runtime.module(define4);
  main.import("convertVsonModel", child4);
  var child5 = runtime.module(define5);
  main.import("Geometries", child5);
  main.import("meshGroup", child5);
  main.import("phiPowerInput", child5);
  main.import("quaternionInput", child5);
  var child6 = runtime.module(define6);
  main.import("scalarmul", child6);
  main.import("quatconj", child6);
  main.import("quatmul", child6);
  main.import("grpow", child6);
  main.import("grfloat", child6);
  main.import("grprint", child6);
  main.import("grprintraw", child6);
  var child7 = runtime.module(define7);
  main.import("slider", child7);
  main.import("color", child7);
  main.import("input", child7);
  var child8 = runtime.module(define8);
  main.import("reusable3dCanvas", child8);
  return main;
}